import {
  SELEZIONA_DETTAGLIO_CRIMINE,
  PULISCI_DETTAGLIO_CRIMINE,
  DEFINISCI_STATI_RAPINA,
  DEFINISCI_STATI_INTERVENTI_RAPINA,
  DEFINISCI_STATI_BOTTINO_RAPINA,
  DEFINISCI_STATI_CONSEGUENZE_RAPINA,
  DEFINISCI_STATI_FURTO,
  DEFINISCI_STATI_INTERVENTI_FURTO,
  DEFINISCI_STATI_BOTTINO_FURTO,
  DEFINISCI_STATI_CONSEGUENZE_FURTO,
  DEFINISCI_STATI_MODALITA,
  DEFINISCI_STATI_COSTI_EVENTO,
  DEFINISCI_STATI_OSTAGGI,
  DEFINISCI_STATI_ALTRIEVENTI
} from 'Actions/ossif/ossifTypes'
// initial state
const INIT_STATE = {
  dettaglioCrimine: null,

  domandeRisposteRapina: null,
  domandeRisposteIntervento_Rapina: null,
  domandeRisposteBottino_Rapina: null,
  domandeRisposteConseguenze_Rapina: null,

  domandeRisposteFurto: null,
  domandeRisposteBottino_Furto: null,
  domandeRisposteIntervento_Furto: null,
  domandeRisposteConseguenze_Furto: null,

  domandeRisposteModalita: null,
  domandeRisposteCostiEvento: null,
  domandeRisposteOstaggi: null
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELEZIONA_DETTAGLIO_CRIMINE:
      return {
        ...state,
        dettaglioCrimine: action.payload
      }

    case PULISCI_DETTAGLIO_CRIMINE:
      return {
        ...state,
        dettaglioCrimine: null,
        domandeRisposteRapina: null,
        domandeRisposteIntervento_Rapina: null,
        domandeRisposteBottino_Rapina: null,
        domandeRisposteConseguenze_Rapina: null,

        domandeRisposteFurto: null,
        domandeRisposteBottino_Furto: null,
        domandeRisposteIntervento_Furto: null,
        domandeRisposteConseguenze_Furto: null,

        domandeRisposteModalita: null,
        domandeRisposteCostiEvento: null,
        domandeRisposteOstaggi: null,
        domandeRisposteAltriEventi: null
      }

    case DEFINISCI_STATI_RAPINA:
      return {
        ...state,
        domandeRisposteRapina: action.payload
      }

    case DEFINISCI_STATI_INTERVENTI_RAPINA:
      return {
        ...state,
        domandeRisposteIntervento_Rapina: action.payload
      }
    case DEFINISCI_STATI_BOTTINO_RAPINA:
      return {
        ...state,
        domandeRisposteBottino_Rapina: action.payload
      }
    case DEFINISCI_STATI_CONSEGUENZE_RAPINA:
      return {
        ...state,
        domandeRisposteConseguenze_Rapina: action.payload
      }
    case DEFINISCI_STATI_FURTO:
      return {
        ...state,
        domandeRisposteFurto: action.payload
      }
    case DEFINISCI_STATI_INTERVENTI_FURTO:
      return {
        ...state,
        domandeRisposteIntervento_Furto: action.payload
      }
    case DEFINISCI_STATI_BOTTINO_FURTO:
      return {
        ...state,
        domandeRisposteBottino_Furto: action.payload
      }
    case DEFINISCI_STATI_CONSEGUENZE_FURTO:
      return {
        ...state,
        domandeRisposteConseguenze_Furto: action.payload
      }

    case DEFINISCI_STATI_MODALITA:
      return {
        ...state,
        domandeRisposteModalita: action.payload
      }
    case DEFINISCI_STATI_COSTI_EVENTO:
      return {
        ...state,
        domandeRisposteCostiEvento: action.payload
      }
    case DEFINISCI_STATI_OSTAGGI:
      return {
        ...state,
        domandeRisposteOstaggi: action.payload
      }
    case DEFINISCI_STATI_ALTRIEVENTI:
      return {
        ...state,
        domandeRisposteAltriEventi: action.payload
      }

    default:
      return { ...state }
  }
}
